import { useEntityIdSelector } from '../../../redux/entity-id-selector.hook';
import { requestStatusAPI } from '../redux/request-status.slice';

export function useRequestStatus(id: string) {
  const { entity: requestStatus } = useEntityIdSelector(requestStatusAPI, id);
  return { requestStatus };
}
